import React from "react";
import Sidebar from "../profile-sidebar/profileSidebar";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
const MyProfile = () => {
  const { userInfo } = useSelector((state) => state.user);
  return (
    <div>
      {/* <!-- Page Wrapper --> */}
      <div className="content">
        <div className="container">
          <div className="row">
            {/* <!-- Sidebar --> */}
            <Sidebar page="my-profile" />
            {/* <!-- /Sidebar --> */}

            {/* My Profile */}
            <div className="col-xl-9 col-lg-8">
              <div className="card shadow-none mb-0">
                <div className="card-header d-flex align-items-center justify-content-between">
                  <h6>Thông tin cá nhân</h6>
                  <div className="d-flex align-items-center justify-content-center">
                    <Link
                      to="/update-user"
                      className="p-1 rounded-circle btn btn-light d-flex align-items-center justify-content-center"
                    >
                      <i className="isax isax-edit-2 fs-14"></i>
                    </Link>
                  </div>
                </div>
                <div className="card-body">
                  <h6 className="fs-16 mb-3">Thông tin cơ bản</h6>
                  <div className="d-flex align-items-center mb-3">
                    <span className="avatar avatar-xl flex-shrink-0 me-3 ">
                      <img
                        src={
                          userInfo && userInfo.imageUrl ? userInfo.imageUrl : ""
                        }
                        alt="Img"
                        className="img-fluid rounded"
                      />
                    </span>
                  </div>
                  {userInfo && userInfo.statusGuide ? (
                    <div className="col-md-6">
                      <div className="mb-2">
                        <h6 className="fs-14">Trạng thái hướng dẫn viên</h6>
                        <p>
                          {userInfo.statusGuide === "Pending" && (
                            <i
                              className="fa-solid fa-hourglass-half"
                              style={{ color: "#ffc800" }}
                            ></i>
                          )}
                          {userInfo.statusGuide === "Available" && (
                            <i
                              className="fa-solid fa-circle-check"
                              style={{ color: "#28a745" }}
                            ></i>
                          )}
                          {userInfo.statusGuide === "Busy" && (
                            <i
                              className="fa-solid fa-circle-xmark"
                              style={{ color: "#dc3545" }}
                            ></i>
                          )}
                          <span className="ms-2">
                            {userInfo.statusGuide === "Pending"
                              ? userInfo.statusGuide +
                                " " +
                                "(Update thêm thông tin)"
                              : userInfo.statusGuide}
                          </span>
                        </p>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="row border-bottom pb-2 mb-3">
                    <div className="col-md-6">
                      <div className="mb-2">
                        <h6 className="fs-14">Tên</h6>
                        <p>
                          {userInfo && userInfo.fullName ? (
                            userInfo.fullName
                          ) : (
                            <i
                              className="fa-solid fa-triangle-exclamation"
                              style={{ color: "#ffc800" }}
                            ></i>
                          )}
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-2">
                        <h6 className="fs-14">Địa chỉ</h6>
                        <p>
                          {userInfo &&
                          userInfo.address &&
                          userInfo.address.trim() ? (
                            userInfo.address
                          ) : (
                            <>
                              <i
                                className="fa-solid fa-triangle-exclamation"
                                style={{ color: "#ffc800" }}
                              ></i>
                            </>
                          )}
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-2">
                        <h6 className="fs-14">Email</h6>
                        <p>
                          {userInfo && userInfo.email ? (
                            userInfo.email
                          ) : (
                            <i
                              className="fa-solid fa-triangle-exclamation"
                              style={{ color: "#ffc800" }}
                            ></i>
                          )}
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-2">
                        <h6 className="fs-14">Số điện thoại</h6>
                        <p>
                          {userInfo && userInfo.phoneNumber ? (
                            userInfo.phoneNumber
                          ) : (
                            <i
                              className="fa-solid fa-triangle-exclamation"
                              style={{ color: "#ffc800" }}
                            ></i>
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyProfile;
